import { render, staticRenderFns } from "./RecebimentosListaForm.vue?vue&type=template&id=0d05edff&scoped=true&"
import script from "./RecebimentosListaForm.vue?vue&type=script&lang=js&"
export * from "./RecebimentosListaForm.vue?vue&type=script&lang=js&"
import style0 from "./RecebimentosListaForm.vue?vue&type=style&index=0&id=0d05edff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d05edff",
  null
  
)

export default component.exports